import { PurchaseOrderStatus } from 'types/purchaseOrders';

export const STATUS = Object.freeze([
  PurchaseOrderStatus.Created,
  PurchaseOrderStatus.ReceivingStarted,
  PurchaseOrderStatus.Received,
]);
